export const NOT_LOADED = 0;
export const LOADING = 1;
export const FINISHED = 2;
